import React from "react";
import { Row, Col, Card, Typography, Tooltip, Flex, Grid, Input } from "antd";
import { styled } from "@mui/system";
const DataSheet = styled('div')`
    .ant-card-small >.ant-card-body {
      padding: 8px 8px;
      }
      margin: 2px 2px;
`;
const { Text } = Typography;
const { useBreakpoint } = Grid;

export default function DetailsGrid({ infoItems = [] , fullWidth=false, size}) {
  const screens = useBreakpoint(); 

  return (
    <DataSheet>
    <Row gutter={[6, 6]}>
      {infoItems.map((item, index) => {
        const isInput = item.type === "input";
        return(
        <Col xs={24} sm={24} md={fullWidth ? 24:  12} lg={fullWidth ? 24 : size == "small" ? 8 :  12} key={index}>
          <Card
            size="small"
            style={{
              borderRadius: 12,
              background: '#f1f1f1',
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                marginBottom: 4,
            }}
          >
            <Flex
              vertical={!screens.lg || isInput} 
              justify="space-between"
              align={isInput ? "start" : screens.lg ? "center" : "start"}
              gap={6}
              wrap
            >
              <Flex align="center" gap={8}>
                {item.icon}
                <span style={{ fontWeight: 600, fontSize: size === 'small' ? '14px' : '17px', color: "#595959" }}>
                  {item.label}
                </span>
              </Flex>
            {
                item?.type !== 'link' && item?.type !== 'text' ? (
                    <Tooltip title={item?.label === 'Product' ? item.value : ''}>
                    <Input
                    value={item.value}
                    readOnly
                    style={{
                        background: "#fafafa",
                        borderRadius: 8,
                        cursor: "default",
                        fontWeight: 500,
                        color: "#262626",
                        maxWidth:  "100%",
                        
                    }}
                    />
                    </Tooltip>
                ) : ( <Tooltip title={(item?.label === 'Product' || item?.label === 'Customer') && item.value}>
                <Text
                  strong
                  // ellipsis
                  style={{
                    maxWidth: screens.lg ? "100%" : "100%",
                    textAlign: screens.lg ? "right" : "left",
                    fontSize: fullWidth ? '16px' : '16px',
                    color: item?.color || ''
                  }}
                >
                  {item.value === null || item.value === undefined ? "-" : item.value}
                </Text>
              </Tooltip>)
            }
             
            </Flex>
          </Card>
        </Col>
      )})}
    </Row>
    </DataSheet>
  );
}
